import { createApp } from "vue";
import App from "./App.vue";
import notitia from "./plugins/notitia";
import { createPinia } from "pinia";
import { loadFonts } from "./plugins/webfontloader";
import "flag-icons/css/flag-icons.min.css";
import router from "./router";
// import { H } from "highlight.run";

import "@mdi/font/css/materialdesignicons.css";
import "@lr-notitia/notitia-ui/styles";
import "vuetify/styles";
import "../public/style_overrides.css";

// override some teamly vuetify styles
import "@lr-notitia/teamly/styleOverrides";
import Components from "@lr-notitia/teamly/components";

// if (import.meta.env.MODE != "development") {
// 	H.init("7e3nyqd1", {
// 		environment: "production",
// 		networkRecording: {
// 			enabled: true,
// 			recordHeadersAndBody: true,
// 		},
// 	});
// }

const app = createApp(App);

// Groupware Vue Components
for (const [key, value] of Object.entries(Components)) {
	app.component(key, value);
}

loadFonts();

app.use(router).use(notitia).use(createPinia()).mount("#app");
